import { DisplayData } from '../../helpers/Controls';

export const UnitedStatesIso3 = 'USA';
export const CanadaIso3 = 'CAN';

export interface DisplayDataCountry extends DisplayData {
  countryIso2: string;
  phonePrefix: string;
  postalCodeFormat: RegExp;
}

export const countries: DisplayDataCountry[] = [
  {
    display: 'Canada',
    data: CanadaIso3,
    countryIso2: 'CA',
    phonePrefix: '+1',
    // eslint-disable-next-line no-useless-escape
    postalCodeFormat: /^[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ -]?\d[ABCEGHJ-NPRSTV-Z]\d$/,
  },
  {
    display: 'United States',
    data: UnitedStatesIso3,
    countryIso2: 'US',
    phonePrefix: '+1',
    // eslint-disable-next-line no-useless-escape
    postalCodeFormat: /^\d{5}([\-]?\d{4})?$/,
  },
];

export function getCountries(): DisplayData[] {
  return countries;
}

// Convert any Iso2 Country to Iso3 Country
export function countryIso2ToIso3(country: string): string {
  if (country) {
    // Lookup using Iso3 Country
    const countriesFilteredIso3: DisplayDataCountry[] = countries.filter((countryOption: DisplayDataCountry) => countryOption.data === country);

    if (countriesFilteredIso3.length > 0) {
      return countriesFilteredIso3[0].data;
    }

    // Lookup using Iso2 Country
    const countriesFilteredIso2: DisplayDataCountry[] = countries.filter(
      (countryOption: DisplayDataCountry) => countryOption.countryIso2 === country,
    );

    if (countriesFilteredIso2.length > 0) {
      return countriesFilteredIso2[0].data;
    }
  }

  return null;
}

export function countryNameToAbbreviation(country: string): string {
  if (country) {
    const countriesFiltered: DisplayDataCountry[] = countries.filter((countryOption: DisplayDataCountry) => countryOption.display === country);

    if (countriesFiltered.length > 0) {
      return countriesFiltered[0].data;
    }
  }

  return country;
}

export function countryAbbreviationToName(country: string): string {
  if (country) {
    // Lookup using Iso3 Country
    const countriesFilteredIso3: DisplayDataCountry[] = countries.filter((countryOption: DisplayDataCountry) => countryOption.data === country);

    if (countriesFilteredIso3.length > 0) {
      return countriesFilteredIso3[0].display;
    }

    // Lookup using Iso2 Country
    const countriesFilteredIso2: DisplayDataCountry[] = countries.filter(
      (countryOption: DisplayDataCountry) => countryOption.countryIso2 === country,
    );

    if (countriesFilteredIso2.length > 0) {
      return countriesFilteredIso2[0].display;
    }
  }

  return country;
}

export function getPhonePrefixForCountry(country: string): string {
  if (country) {
    // Lookup using Iso3 Country
    const countriesFilteredIso3: DisplayDataCountry[] = countries.filter((countryOption: DisplayDataCountry) => countryOption.data === country);

    if (countriesFilteredIso3.length > 0) {
      return countriesFilteredIso3[0].phonePrefix;
    }

    // Lookup using Iso2 Country
    const countriesFilteredIso2: DisplayDataCountry[] = countries.filter(
      (countryOption: DisplayDataCountry) => countryOption.countryIso2 === country,
    );

    if (countriesFilteredIso2.length > 0) {
      return countriesFilteredIso2[0].phonePrefix;
    }
  }

  return null;
}
